import { c as _c } from "react/compiler-runtime";
import { copyToClipboard, delay } from 'betterplace-utils';
import classNames from 'classnames';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { LayoutCluster } from '../layouts';
import { TextInput } from '../TextInput';
import styles from './CopyText.module.css';
import { type CopyTextProps, CopyTextState } from './types';
function CopyText(t0) {
  const $ = _c(25);
  const {
    textToCopy,
    showPreview: t1,
    previewLabel,
    previewHint,
    children,
    onTextCopied,
    onError,
    className,
    fadeOutDelay: t2,
    idleDelay: t3
  } = t0;
  const showPreview = t1 === undefined ? false : t1;
  const fadeOutDelay = t2 === undefined ? 3000 : t2;
  const idleDelay = t3 === undefined ? 200 : t3;
  const [state, setState] = useState(CopyTextState.Idle);
  let t4;
  if ($[0] !== fadeOutDelay || $[1] !== idleDelay) {
    t4 = async () => {
      await delay(fadeOutDelay);
      setState(CopyTextState.FadingOut);
      await delay(idleDelay);
      setState(CopyTextState.Idle);
    };
    $[0] = fadeOutDelay;
    $[1] = idleDelay;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const animateOut = t4;
  let t5;
  let t6;
  if ($[3] !== animateOut || $[4] !== state) {
    t5 = () => {
      if (state !== CopyTextState.Success && state !== CopyTextState.Error) {
        return;
      }
      animateOut().then().catch(console.error);
    };
    t6 = [animateOut, state];
    $[3] = animateOut;
    $[4] = state;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  useEffect(t5, t6);
  let t7;
  if ($[7] !== onError || $[8] !== onTextCopied || $[9] !== textToCopy) {
    t7 = () => {
      if (!textToCopy) {
        return;
      }
      copyToClipboard(textToCopy).then(() => {
        onTextCopied?.(textToCopy);
        setState(CopyTextState.Success);
      }).catch(error => {
        setState(CopyTextState.Error);
        onError?.(error as Error);
      });
    };
    $[7] = onError;
    $[8] = onTextCopied;
    $[9] = textToCopy;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const copyText = t7;
  let t8;
  if ($[11] !== children || $[12] !== copyText || $[13] !== state) {
    t8 = children(copyText, state);
    $[11] = children;
    $[12] = copyText;
    $[13] = state;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const memoised = t8;
  if (showPreview) {
    let t9;
    if ($[15] !== className) {
      t9 = classNames(styles.copyTextContainer, className);
      $[15] = className;
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    const t10 = textToCopy as string;
    let t11;
    if ($[17] !== previewHint || $[18] !== previewLabel || $[19] !== t10) {
      t11 = <TextInput className={styles.copyTextInput} readOnly={true} label={previewLabel} description={previewHint} value={t10} />;
      $[17] = previewHint;
      $[18] = previewLabel;
      $[19] = t10;
      $[20] = t11;
    } else {
      t11 = $[20];
    }
    let t12;
    if ($[21] !== memoised || $[22] !== t11 || $[23] !== t9) {
      t12 = <LayoutCluster className={t9}>{t11}{memoised}</LayoutCluster>;
      $[21] = memoised;
      $[22] = t11;
      $[23] = t9;
      $[24] = t12;
    } else {
      t12 = $[24];
    }
    return t12;
  }
  return memoised;
}
export default CopyText;